import { useTranslation } from 'react-i18next';

import { ReactComponent as RefreshIcon } from '../../assets/icons/dashboard/rotate-left.svg';
import { ReactComponent as FilterClose } from '../../assets/icons/filter-close.svg';
import { ReactComponent as Filter } from '../../assets/icons/filter.svg';
import { ReactComponent as LargeFontIcon } from '../../assets/icons/table-component/large-font-icon.svg';
import { ReactComponent as MediumFontIcon } from '../../assets/icons/table-component/medium-font-icon.svg';
import { ReactComponent as SmallFontIcon } from '../../assets/icons/table-component/small-font-icon.svg';
import MyButton from '../button/Button';
import ExportButton from '../export-button/ExportButton';
import TableFieldAllow from '../table-field-allow/TableFieldAllow';

interface TopHeaderButtonInterFace {
  filterFunction: () => void;
  filterClearFunction: () => void;
  sizeChangeFunction?: () => void;
  currentFontSize?: string;
  sizeChangeButtonRequired?: boolean;
  filterAllow?: boolean;
  rightTopContent?: JSX.Element;
  leftTopContent?: JSX.Element;
  refreshRequired?: boolean;
  handleRefresh?: () => void;
  hoverLabel?: string;
  exportDataPdfOrCSV?: (type: 'pdf' | 'csv') => void;
  exportData?: any[];
  exportLoader?: boolean;
  labelForHideColumn?: {
    label: string;
    accessorKey: any;
    disableHideFunc: boolean;
  }[];
  hidedColumn?: string[];
  setHidedColumn?: React.Dispatch<React.SetStateAction<string[]>>;
  isFicility?: boolean;
}

/**
 * Top header buttons function component
 */
function TopHeaderButtons({
  filterFunction,
  filterClearFunction,
  currentFontSize,
  sizeChangeFunction,
  sizeChangeButtonRequired,
  leftTopContent,
  rightTopContent,
  filterAllow,
  refreshRequired,
  handleRefresh,
  hoverLabel,
  exportDataPdfOrCSV,
  exportData,
  exportLoader,
  labelForHideColumn,
  hidedColumn,
  setHidedColumn,
  isFicility,
}: TopHeaderButtonInterFace) {
  const { t } = useTranslation('customTable');

  /**
   * Function to decide font change to show
   * @returns JSX.Element as an svg icon
   */
  const handleFontChangeIcon = (): JSX.Element => {
    let icon;
    switch (currentFontSize) {
      case 'large':
        icon = <LargeFontIcon />;
        break;
      case 'medium':
        icon = <MediumFontIcon />;
        break;
      default:
        icon = <SmallFontIcon />;
        break;
    }
    return icon;
  };
  return (
    <div className="top-header-warp-v1">
      <div className="top-header-buttons">
        <div className="top-header-right">
          {rightTopContent && rightTopContent}

          <div className="export-data-content">
            {exportDataPdfOrCSV && isFicility && (
              <div className="export-data">
                <ExportButton
                  label=""
                  buttonList={[
                    {
                      key: 'pdf',
                      allow: true,
                      /**
                       * Export pdf function
                       * @returns
                       */
                      onClickFunction: () => exportDataPdfOrCSV('pdf'),
                    },
                    {
                      key: 'csv',
                      allow: true,
                      /**
                       * Export csv function
                       * @returns
                       */
                      onClickFunction: () => exportDataPdfOrCSV('csv'),
                    },
                  ]}
                  disabled={exportData?.length === 0}
                  loader={exportLoader}
                  version="v2"
                  hoverLabel={t('export')}
                />
              </div>
            )}
          </div>
          {refreshRequired && (
            <MyButton
              label=""
              buttonType="none"
              onClickFunc={handleRefresh}
              svgIcon={<RefreshIcon />}
              hoverLabel={hoverLabel}
            />
          )}
          {sizeChangeButtonRequired  && (
            <MyButton
              label=""
              buttonType="none"
              onClickFunc={sizeChangeFunction}
              svgIcon={handleFontChangeIcon()}
              hoverLabel={t('textSize')}
            />
          )}
          {hidedColumn && setHidedColumn && labelForHideColumn && isFicility &&(
            <div className="hided-colum-data">
              <TableFieldAllow
                labelForHideColumn={labelForHideColumn}
                hidedColumn={hidedColumn}
                setHidedColumn={setHidedColumn}
                hoverLabel={t('columnHide')}
              />
            </div>
          )}
        </div>
        <div className="top-header-left">
          {leftTopContent && leftTopContent}
          {filterAllow && (
            <div className="button-group">
              <div className="button-item">
                <MyButton
                  label=""
                  buttonType="none"
                  onClickFunc={filterFunction}
                  svgIcon={<Filter />}
                />
              </div>
              <div className="button-item">
                <MyButton
                  label=""
                  buttonType="none"
                  onClickFunc={filterClearFunction}
                  svgBackIcon={<FilterClose />}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

TopHeaderButtons.defaultProps = {
  /**
   * Size change function
   */
  sizeChangeFunction: () => {},
  sizeChangeButtonRequired: false,
  rightTopContent: null,
  leftTopContent: null,
  filterAllow: true,
  currentFontSize: 'small',
  refreshRequired: false,
  /**
   * Refresh function
   */
  handleRefresh: () => {},
  hoverLabel: '',
  exportData: [],
  exportLoader: false,
  /**
   * Refresh function
   */
  exportDataPdfOrCSV: () => {},
  labelForHideColumn: {},
  hidedColumn: [],
  setHidedColumn: [],
  isFicility: true,
};

export default TopHeaderButtons;
